<h5 [className]="customClass">
    <strong>{{ this.currentStep?.step }}/{{ currentStep?.total }}</strong>
    {{ currentStep?.description }}
</h5>
